import axios from '../../axios'
import router from '@/router'

const state = {
	token: null,
	user: null,
	showLoginRegister: false,
	verifyEmail: {
		show: false,
		email: null,
		continueToSetPassword: false,
		updateUser: false
	},
	setPassword: {
		show: false,
		email: null
	},
	showChangePassword: false
}

const getters = {
	token(state) {
		return state.token
	},
	authenticated(state) { 
		return state.token && state.user 
	},
	user (state) {
		return state.user
	},
	showLoginRegister(state) {
		return state.showLoginRegister
	},
	getVerifyEmail(state) {
		return state.verifyEmail
	},
	getSetPassword(state) {
		return state.setPassword
	},
	showChangePassword(state) {
		return state.showChangePassword
	}
}

const mutations = {
	SET_TOKEN (state, token) {
		state.token = token
	},
	SET_USER (state, user) {
		state.user = user
	},
	SET_LOGIN_REGISTER (state, showLoginRegister) {
		state.showLoginRegister = showLoginRegister
	},
	SET_VERIFY_EMAIL(state, verifyEmail) {
		state.verifyEmail = verifyEmail
	},
	SET_SET_PASSWORD(state, setPassword) {
		state.setPassword = setPassword
	},
	SET_CHANGE_PASSWORD(state, showChangePassword) {
		state.showChangePassword = showChangePassword
	}
}

const actions = {
	async loginWithEmail({ commit, dispatch }, credentials) {
		commit('HTTP_IN_PROGRESS')
		let response = await axios.post('token', credentials, { withCredentials: true })

		return dispatch('attempt', response.data.access_token)
	},

	async loginWithProvider({ commit, dispatch }, credentials) {
		commit('HTTP_IN_PROGRESS')
		let response = await axios.post('user-provider', credentials, { withCredentials: true })

		return dispatch('attempt', response.data.access_token)
	},

	async register({ commit, dispatch }, credentials) {
		commit('HTTP_IN_PROGRESS')
		await axios.post('user', credentials)

		return dispatch('loginWithEmail', credentials)
	},

	async attempt({dispatch, commit}, token) {
		if(token) {
			commit('SET_TOKEN', token)
		}
		if(!state.token) {
			commit('SET_TOKEN', null)
		}

		try {
			let response = await axios.get('user')
			await dispatch('getCurrentPools')
			commit('SET_USER', response.data.data)
			commit('SET_LOGIN_REGISTER', false)
		} catch (e) {
			commit('SET_TOKEN', null)
			commit('SET_USER', null)
			commit('SET_LOGIN_REGISTER', false)
		}
	},

	logout({ commit }) {
		return axios.delete('token', { withCredentials: true }).then(() => {
			commit('HTTP_FINISHED')
			commit('SET_TOKEN', null)
			commit('SET_USER', null)
			if(router.currentRoute.name != 'home') {
				router.push('/')
			} 
		})
	},

	async sendEmailVerificationLink({ commit }, email) {
		commit('HTTP_IN_PROGRESS')
		return axios.post('verification-code', email)
	},

	async verifyEmail({ commit, dispatch }, data) {
		commit('HTTP_IN_PROGRESS')
		await axios.post('email-verification', data)

		return dispatch('attempt')
	},

	async setPassword({ commit, dispatch }, data) {
		commit('HTTP_IN_PROGRESS')
		await axios.put('password', data)
		return dispatch('attempt')
	},

	changePassword({ commit }, data) {
		commit('HTTP_IN_PROGRESS')
		return axios.put('password', data)
	},

	async removeSocialProvider({ commit, dispatch }, id) {
		commit('HTTP_IN_PROGRESS')
		await axios.delete('user-provider/'.concat(id))
		return dispatch('attempt')
	},
	attemptRefresh({ dispatch, commit }) {
		return axios.put('/token', null, { withCredentials: true }).then(response => {
			commit('SET_TOKEN', response.data.access_token)
			return dispatch('attempt').then(() => {
				return 'success'
			})
			
		}).catch(() => {
			return 'error'
		})		
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}